import { FlexContainer } from '@act/storybook';
import { SurveyV2, UserDto } from '@act/shared/data-transfer-objects';
import { applyMustacheTemplate } from '@act/shared/utilities';
import { Typography } from '@mui/material';

export interface SurveyTitleSectionProps {
  survey: SurveyV2.SurveyDto;
  member: UserDto;
  /** Epoch ms when the survey was assigned; month label uses UTC calendar when set. */
  assignmentCreatedAt?: number;
}

const SurveyTitleSection = ({
  survey,
  member,
  assignmentCreatedAt,
}: SurveyTitleSectionProps) => {
  // Early return if no member data
  if (!member) {
    return (
      survey?.displayName && (
        <FlexContainer
          direction="column"
          gap={1}
          height="auto"
          overflowAllVisible
          padding="8px 0 16px"
        >
          <Typography display="block" variant="headlineMedium">
            {survey.displayName || ''}
          </Typography>
          <Typography variant="bodyLarge">{survey.summary || ''}</Typography>
        </FlexContainer>
      )
    );
  }

  const monthLabel =
    assignmentCreatedAt != null
      ? new Date(assignmentCreatedAt).toLocaleString('default', {
          month: 'long',
          timeZone: 'UTC',
        })
      : new Date().toLocaleString('default', { month: 'long' });

  const surveyTemplateVariables = {
    memberName: `${member?.firstName}`,
    month: monthLabel,
  };
  const surveyTitle = applyMustacheTemplate(survey?.displayName || '', surveyTemplateVariables);

  return (
    (survey?.displayName || survey?.summary) && (
      <FlexContainer
        direction="column"
        gap={1}
        height="auto"
        overflowAllVisible
        padding="8px 0 16px"
      >
        <Typography display="block" variant="headlineMedium">
          {surveyTitle}
        </Typography>
        <Typography variant="bodyLarge">
          {survey.summary
            ? applyMustacheTemplate(survey.summary, surveyTemplateVariables)
            : ''}
        </Typography>
      </FlexContainer>
    )
  );
};

export default SurveyTitleSection;
